<template>
  <div v-if="userstatus == 2">
    <div style="height: 20px; width: 100%"></div>
    <div class="flexbox alert">
      <i class="iconfont icon-warning"></i>
      <div class="flexbox text">{{ $t("tips.aproval") }}</div>
    </div>

    <div class="flexbox logout" @click="logout">
      {{ $t("navigator.signout") }}
    </div>
  </div>
  <div v-else-if="isLogin">
    <router-view v-slot="{ Component }">
      <keep-alive :key="cacheSession" include="MobileHomeIndex,MobileTrend">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>
<script>
const cachedPaths = ["/m/home/index", "/m/home/trend/list"];

export default {
  data () {
    return {
      msg: 'Mobile Home',
      scrollPositions: {},
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.User.isLogin;
    },
    cacheSession () {
      return `${this.$store.state.User.id}:${this.isLogin}`;
    },
    username () {
      return this.$store.state.User.username;
    },
    userstatus () {
      return this.$store.state.User.status;
    },
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler (path) {
        this.restoreScroll(path);
      },
    },
    cacheSession () {
      this.scrollPositions = {};
      this.restoreScroll(this.$route.path);
    },
  },
  beforeRouteUpdate (to, from, next) {
    // 在旧页面移除前记录位置，避免长列表切到短页面后被浏览器截断。
    if (cachedPaths.includes(from.path)) {
      this.scrollPositions[from.path] = window.pageYOffset;
    }
    next();
  },
  methods: {
    restoreScroll (path) {
      if (!cachedPaths.includes(path)) return;
      this.$nextTick(() => {
        if (this.isLogin && this.$route.path === path) {
          window.scrollTo({ top: this.scrollPositions[path] || 0, left: 0, behavior: "auto" });
        }
      });
    },
    async logout () {
      if (!await this.$store.dispatch("logout")) return;
      let pre = this.util.judgeTerminal() ? "m" : "w";
      this.$router.push({ name: pre + "Login" });
    },
  },
  created () {
    this.$store.dispatch("getStoreList");
    this.$store.dispatch('initWebsocket');
    this.$store.dispatch('getMessage');
  },
}
</script>

<style lang="scss" scoped>
.alert {
  width: 80%;
  margin: 0 auto;
  flex-wrap: nowrap;
  padding: 10px 30px;
  border: 1px solid #f66;
  border-radius: 10px;
  i {
    font-size: 20px;
    flex-shrink: 0;
    color: #f66;
  }
  .text {
    width: 100%;
    color: #f66;
  }
}

.logout {
  position: fixed;
  width: 80%;
  height: 50px;
  font-size: 20px;
  background-color: #f66;
  color: #fff;
  border-radius: 10px;
  bottom: 50px;
  left: 10%;
}
</style>
